import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ user, children }) => {
  if (user === true) {
    return children
  }
  else {
    return <Navigate to='/' />
  }
};

export default ProtectedRoute;
